export class DataClassesFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "containsAnyOf",
            "baseName": "containsAnyOf",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "containsNoneOf",
            "baseName": "containsNoneOf",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "containsAllOf",
            "baseName": "containsAllOf",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataClassesFilters.attributeTypeMap;
    }
    constructor() {
    }
}
